import axios from '@/extensions/axios'

// Site actions
const actions = {
  create ({ commit, state }) {
    return axios.post('brands/' + state.newSite.brand.uuid + '/sites', {
      ...state.newSite,
      default_language_id: state.newSite.defaultLanguage.id
    }).then(({ data }) => {
      commit('ADD', data)
      commit('CLEAR_NEW')
    })
  },

  save ({ commit }, site) {
    return axios.put('sites/' + site.id, {
      ...site,
      default_language_id: site.defaultLanguage ? site.defaultLanguage.id : site.default_language_id
    }).then(({ data }) => {
      commit('ADD', data)
      commit('SET_ACTIVE', data.slug)
    })
  },

  remove ({ commit }, site) {
    return axios.delete('sites/' + site.id).then(() => {
      commit('REMOVE', site)
    })
  },

  get ({ commit }, brand) {
    return axios.get('brands/' + brand + '/all-sites')
      .then(({ data }) => {
        commit('SET', data)
      })
  },

  find ({ commit }, id) {
    return axios.get('sites/' + id)
      .then(({ data }) => {
        commit('ADD', data)
        return data
      })
  },

  restore ({ commit }, site) {
    return axios.patch('sites/' + site.id + '/restore')
      .then(() => {
        commit('RESTORE', site)
      })
  },

  getAllSites ({ commit }) {
    return axios.get('sites').then(({ data }) => {
      commit('SET_ALL_SITES', data)
    })
  },

  getComponents ({ state }) {
    return axios.get('sites/' + state.active.id + '/brand-components')
  },

  removeLanguage ({ state }, languageId) {
    return axios.delete('sites/' + state.active.id + '/languages/' + languageId)
  },

  addLanguage ({ state }, languageId) {
    return axios.post('sites/' + state.active.id + '/languages', {
      language_id: languageId
    })
  }
}

export default actions
